"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Kochava = void 0;
var Kochava = /** @class */ (function () {
    function Kochava(app_id, verbose, use_cookie, disable_auto_install, custom_traits) {
        var SDK_VERSION = "Web 2.5.0 (NPM 1.0.6)";
        var KOCHAVA_CONTROL = "web-sdk.control.kochava.com/track/json";
        var IDENTITY_LINK_ENDPOINT = "web-sdk.control.kochava.com/v1/cpi/identityLink.php";
        var RESOLVER = "identity-resolver.api.kochava.com";
        var MAX_RETRIES = 10;
        var MAX_RETRY_DELAY_MS = 60000;
        var rawID = getLocalValue("kv_id", "kv_id", use_cookie);
        this.kochavaState = {
            appID: app_id,
            kochavaDeviceID: determineKvID(rawID, use_cookie),
            sdkVersion: SDK_VERSION,
            kochavaControl: KOCHAVA_CONTROL,
            identityLinkEndpoint: IDENTITY_LINK_ENDPOINT,
            resolver: RESOLVER,
            utm: getLocalValue("ko_click_id", app_id + "_click", use_cookie),
            useCookie: use_cookie || false,
            verbose: verbose || false,
            logging: (console !== null && console !== undefined),
            disableAutoInstall: disable_auto_install || false,
            maxRetries: MAX_RETRIES,
            maxRetryDelayMs: MAX_RETRY_DELAY_MS,
            startTime: new Date().getTime(),
            identityLink: sanitizeIdentityLink(custom_traits),
            pageName: getPageName(),
            eventName: "",
            session: uuidv4().substr(0, 4),
            session_count: readAndUpdateSessionCount()
        };
        //if (this.kochavaState.verbose && this.kochavaState.logging) {
        //console.log("Initialzed kochava state:", this.kochavaState);
        //}
        if (rawID === "") {
            if (!this.kochavaState.disableAutoInstall) {
                this.install();
                if (this.kochavaState.verbose && this.kochavaState.logging) {
                    console.log("Sending automatic install.");
                }
            }
        }
    }
    Kochava.prototype.identify = function (customTraits, callback) {
        var verifiedCustomTraits = sanitizeIdentityLink(customTraits);
        if (verifiedCustomTraits && Object.keys(verifiedCustomTraits).length > 0) {
            this.kochavaState.identityLink = verifiedCustomTraits;
            setLocalValue("c_trt", JSON.stringify(this.kochavaState.identityLink), this.kochavaState.useCookie);
        }
        else {
            this.kochavaState.identityLink = JSON.parse(getLocalValue("c_trt", "c_trt", this.kochavaState.useCookie));
        }
        if (this.kochavaState.identityLink &&
            Object.keys(this.kochavaState.identityLink).length > 0) {
            try {
                var requestObject = {
                    method: "POST",
                    endpoint: this.kochavaState.identityLinkEndpoint,
                    body: getIdentityPayload(this.kochavaState),
                    contentType: "application/json",
                    retries: this.kochavaState.maxRetries,
                    async: true,
                };
                request(this.kochavaState, requestObject, this.kochavaState.maxRetries, callback);
                if (this.kochavaState.logging && this.kochavaState.verbose) {
                    console.log("kochava.identify request: ", requestObject);
                }
            }
            catch (err) {
                if (this.kochavaState.logging && this.kochavaState.verbose) {
                    console.log("kochava.identify error: ", err.message);
                }
            }
        }
    };
    Kochava.prototype.page = function (pageName, optsObject, callback) {
        this.kochavaState.pageName = pageName || this.kochavaState.pageName;
        if (optsObject && Object.keys(optsObject).length > 0)
            this.activity("page", optsObject, callback);
        else
            this.activity("page", {}, callback);
    };
    Kochava.prototype.activity = function (eventName, optsObject, callback) {
        try {
            this.kochavaState.eventName = eventName;
            var options = {
                method: "POST",
                endpoint: this.kochavaState.kochavaControl,
                body: getPayloadBody(this.kochavaState, eventName, optsObject),
                contentType: "application/json",
                retries: this.kochavaState.maxRetries,
                async: true,
            };
            if (this.kochavaState.logging && this.kochavaState.verbose) {
                console.log("kochava request: ", options);
            }
            request(this.kochavaState, options, this.kochavaState.maxRetries, callback);
        }
        catch (err) {
            if (this.kochavaState.logging && this.kochavaState.verbose) {
                console.log("kochava error: ", err.message);
            }
        }
    };
    Kochava.prototype.conversion = function (eventName, optsObject, callback) {
        this.kochavaState.eventName = eventName || "";
        this.activity("conversion_" + eventName, optsObject, callback);
    };
    Kochava.prototype.install = function (callback) {
        this.activity("install", {}, callback);
    };
    Kochava.prototype.installWithIdentity = function (customTraits, callback) {
        this.kochavaState.identityLink = sanitizeIdentityLink(customTraits);
        this.install(callback);
    };
    Kochava.prototype.getKochavaId = function () {
        return this.kochavaState.kochavaDeviceID;
    };
    Kochava.prototype.getMAID = function (apikey, nonce, authCode, async, callback) {
        try {
            var options = {
                method: "GET",
                endpoint: this.kochavaState.resolver + "/maid/get",
                contentType: "application/json",
                retries: this.kochavaState.maxRetries,
                async: async,
                appGuid: apikey,
                authCode: authCode,
                nonce: nonce,
                withCredentials: true,
                secure: true,
            };
            if (this.kochavaState.logging && this.kochavaState.verbose) {
                console.log("kochava.getMAID request: ", options);
            }
            request(this.kochavaState, options, this.kochavaState.maxRetries, callback);
        }
        catch (err) {
            if (this.kochavaState.logging && this.kochavaState.verbose) {
                console.log("kochava.getMAID error: ", err.message);
            }
        }
    };
    return Kochava;
}());
exports.Kochava = Kochava;
;
var request = function (state, request, currRetries, callback) {
    if (!fetch) {
        var err = "Fetch not supported in this browser, use a different browser or \
      older version of the sdk";
        console.log(err);
        if (callback instanceof Function) {
            callback(true, err);
        }
        return;
    }
    var method = request.method, endpoint = request.endpoint, body = request.body, contentType = request.contentType, secure = request.secure;
    method = method || "GET";
    body = body || {};
    contentType = contentType || "application/json";
    if (document && !secure) {
        endpoint =
            ("https:" === document.location.protocol ? "https://" : "http://") +
                endpoint;
    }
    else {
        endpoint = "https://" + endpoint;
    }
    var headers = new Headers();
    headers.append("Content-Type", contentType);
    if ("appGuid" in request) {
        if ("authCode" in request && "nonce" in request) {
            headers.append("Authorization", request.appGuid + ", "
                + request.nonce + ", "
                + request.authCode);
        }
        else {
            //@ts-ignore
            headers.append("Authorization", request.appGuid);
        }
    }
    //if (state.logging && state.verbose) {
    //console.log("Preparing to send request via fetch...");
    //}
    fetch(endpoint, {
        method: method,
        body: JSON.stringify(body),
        headers: headers,
    })
        .then(function (response) {
        //if (state.logging && state.verbose) {
        //console.log("Fetch response received:", response);
        //}
        return response.text();
    })
        .then(function (receivedResponse) {
        //if (state.logging && state.verbose) {
        //console.log("Response converted to text:", receivedResponse);
        //}
        return handleRequestSuccess(state, receivedResponse, callback);
    })
        .catch(function (err) { return handleRequestError(err, state, currRetries, request, callback); });
};
var handleRequestSuccess = function (state, resp, callback) {
    if (state.logging && state.verbose) {
        console.log("event sent successfully");
    }
    if (callback instanceof Function) {
        callback(false, JSON.parse(resp));
    }
};
var handleRequestError = function (err, state, retriesLeft, options, callback) {
    retriesLeft--;
    if (retriesLeft > 0) {
        if (state.logging && state.verbose) {
            console.log("Error: API call failed at the network level. Attempt: " + (state.maxRetries - retriesLeft));
        }
        var delayFactor = state.maxRetries - retriesLeft;
        var delay = delayFactor * delayFactor * 500;
        if (delay > state.maxRetryDelayMs) {
            delay = state.maxRetryDelayMs;
        }
        setTimeout(function () { return request(state, options, retriesLeft, callback); }, delay);
    }
    else {
        if (state.logging && state.verbose) {
            console.log("Error: API call failed at the network level (retry limit hit).", err);
        }
        if (callback instanceof Function) {
            callback(true, err);
        }
    }
};
var getPayloadBody = function (state, eventName, optsObject) {
    //if (state.logging && state.verbose) {
    //console.log("Assembling request payload.");
    //}
    var basePayload = getBasePayload(state, eventName);
    var baseData = getBaseDataPoints(state);
    var specificData;
    switch (eventName) {
        case "install":
            specificData = setInstallData(state, baseData);
            break;
        case "page":
            specificData = setPageData(state, baseData, optsObject);
            break;
        default:
            specificData = setEventData(state, baseData, eventName, optsObject);
            break;
    }
    var fullPayload = __assign(__assign({}, basePayload), { data: __assign({}, specificData) });
    //if (state.logging && state.verbose) {
    //console.log("Full payload assembled", fullPayload);
    //}
    return JSON.parse(JSON.stringify(fullPayload));
};
var setInstallData = function (state, baseData) {
    setLocalValue("kv_install_sent", String(new Date().getTime()), state.useCookie);
    return getInstallDataPoints(state, baseData);
};
var setPageData = function (state, baseData, optsObject) {
    var eventData = { page_name: state.pageName, };
    if (optsObject && Object.keys(optsObject).length > 0) {
        eventData = __assign(__assign({}, eventData), optsObject);
    }
    return getEventDataPoints(baseData, "page", eventData);
};
var setEventData = function (state, baseData, eventName, optsObject) {
    var eventTime = new Date().getTime();
    var timeElapsed = eventTime - state.startTime;
    var timeOnPage = Math.round(timeElapsed / 1000);
    var eventData = {
        page_name: state.pageName,
        time_on_page: timeOnPage
    };
    if (optsObject && Object.keys(optsObject).length > 0) {
        eventData = __assign(__assign({}, eventData), optsObject);
    }
    return getEventDataPoints(baseData, eventName, eventData);
};
var getIdentityPayload = function (state) { return ({
    kochava_app_id: state.appID,
    device_id: {
        kochava_device_id: state.kochavaDeviceID,
    },
    data: state.identityLink,
}); };
var getBasePayload = function (state, eventName) { return ({
    action: getActionName(eventName),
    kochava_app_id: state.appID,
    kochava_device_id: state.kochavaDeviceID,
    sdk_version: state.sdkVersion,
    nt_id: generateNtID(state),
}); };
var getBaseDataPoints = function (state) { return ({
    language: getLanguage(),
    device_orientation: getScreenOrientation(),
    usertime: getCurrentUnixTime(),
    user_agent: getUserAgent(),
    device_ids: {
        kochava_device_id: state.kochavaDeviceID,
    },
    disp_w: (getScreenWidth()) ? getScreenWidth() : 0,
    disp_h: (getScreenHeight()) ? getScreenHeight() : 0,
}); };
var getEventDataPoints = function (baseData, eventName, eventData) {
    return (__assign(__assign({}, baseData), { event_name: eventName, event_data: eventData }));
};
var getInstallDataPoints = function (state, baseData) {
    return (__assign(__assign({}, baseData), { identity_link: state.identityLink }));
};
var determineKvID = function (rawID, use_cookie) {
    return (rawID === "") ? assignNewID(use_cookie) : rawID;
};
var sanitizeIdentityLink = function (idLink) {
    if (idLink && typeof idLink !== "string" && Object.keys(idLink).length > 0) {
        return idLink;
    }
    else if (typeof idLink === "string") {
        return { "custom_id": idLink };
    }
    else {
        return undefined;
    }
};
var getActionName = function (eventName) {
    return eventName === "install" ? "install" : "event";
};
var getUrlParameter = function (name) {
    if (!location || !location.search) {
        return "";
    }
    name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(location.search);
    return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
};
var setLocalStorageValue = function (key, val) {
    if (!localStorage) {
        return false;
    }
    try {
        localStorage.setItem(key, val);
    }
    catch (err) {
        return false;
    }
    return true;
};
var getLocalStorageValue = function (name) {
    if (!localStorage) {
        return "";
    }
    var val = "";
    try {
        val = localStorage.getItem(name) || "";
    }
    catch (err) {
        return "";
    }
    return !(val) ? "" : val;
};
var setCookie = function (name, value) {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + 3650 * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
    document.cookie =
        name +
            "=" +
            (value || "") +
            expires +
            "; Secure; path=/;domain=" +
            getBaseDomain();
};
var getCookie = function (name) {
    var nameEQ = name + "=";
    var carray = document.cookie.split(";");
    carray.forEach(function (c) {
        while (c.charAt(0) == " ")
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0)
            return c.substring(nameEQ.length, c.length);
    });
    return "";
};
var setLocalValue = function (key, val, useCookie) {
    setLocalStorageValue(key, val);
    if (useCookie) {
        setCookie(key, val);
    }
};
var getLocalValue = function (name, storageName, useCookie) {
    var val = getUrlParameter(name);
    if (val === "") {
        val = getLocalStorageValue(storageName);
    }
    else {
        setLocalValue(storageName, val, useCookie);
    }
    if (useCookie) {
        if (val === "") {
            val = getCookie(storageName);
        }
        else {
            setCookie(storageName, val);
            return val;
        }
        if (val !== "") {
            setLocalValue(storageName, val, useCookie);
        }
    }
    return !(val) ? "" : val;
};
var getPageName = function () {
    var page = "";
    if (location) {
        page = location.pathname.substring(1);
        page = page.replace(/\/+$/, "");
    }
    return page === "" ? "/" : page;
};
var getBaseDomain = function () { return window.location.host; };
var getUserAgent = function () {
    return (navigator) ? navigator.userAgent : "";
};
var getLanguage = function () {
    return (navigator) ? navigator.language : "";
};
var getScreenWidth = function () {
    return (window) ? window.screen.availWidth : 0;
};
var getScreenHeight = function () {
    return (window) ? window.screen.availHeight : 0;
};
var getScreenOrientation = function () {
    return (window) ? window.innerWidth < window.innerHeight
        ? "portrait"
        : "landscape"
        : "";
};
var getCurrentUnixTime = function () { return Math.floor(Date.now() / 1000); };
var assignNewID = function (useCookie) {
    // const newId: string = uuid();
    var newID = "KWE" + getCurrentUnixTime() + "T" + uuidv4();
    setLocalValue("kv_id", newID, useCookie);
    return newID;
};
var uuidv4 = function () {
    return (1e7 + "-" + 1e3 + "-" + 4e3 + "-" + 8e3 + "-" + 1e11).replace(/[018]/g, function (c) {
        return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
    });
};
var readAndUpdateSessionCount = function () {
    var storedSessionCount = localStorage.getItem("kv_session_count");
    var sessionCount = 1;
    if (storedSessionCount) {
        sessionCount = parseInt(storedSessionCount);
        sessionCount++;
    }
    localStorage.setItem("kv_session_count", sessionCount.toString());
    return sessionCount;
};
var generateNtID = function (state) {
    return state.session + "-" + state.session_count + "-" + uuidv4();
};
// const uuid = (): string => {
//   let dt: number = new Date().getTime();
//   const uuid: string = "kwxxxxxxxxxxxxx".replace(/[xy]/g, function (c) {
//     const r: number = (dt + Math.random() * 16) % 16 | 0;
//     dt = Math.floor(dt / 16);
//     return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
//   });
//   return uuid;
// };
